<template>
    <div class="gameWheelBox">
        <img :src="`/manager/fileserver/file/download?id=${gameData.topicPic}`" class="bgimg" v-if="gameData.topicPic"/>
        <div class="scrollCent">
            <div class="title">{{gameData.name}}</div>
            <div style="display: none">
                <img ref="imgel" src="../../../assets/img/dial_pointer.png">
            </div>
            <canvas @click="gotoRotate" id="canvas"></canvas>
        </div>

    </div>
</template>

<script>
    export default {
        name: "gameWheel",
        mounted() {
            if(localStorage.getItem("openId")){
                let dt = new URLSearchParams()
                dt.append('openid',localStorage.getItem("openId"))
                this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt).then(({data})=>{ //使用openid获取会员信息
                    if(data.code == 200 && data.data != null){
                        // console.log(data.data)
                        let dataStr = JSON.stringify(data.data)
                        if(data.data.cardAccount){
                            localStorage.setItem("login", '1')
                        }else{
                            localStorage.setItem("login", '0')
                        }

                        localStorage.setItem("userData", dataStr)
                    }else{
                        this.UI.Toast.failed(data.message)
                    }
                })
            }else{
                let dtcode = new URLSearchParams()
                dtcode.append('code', window.MyCode)
                this.$http.post('/sangto-wrm/vip/member/getByCode',dtcode).then(({data})=>{
                    // console.log(JSON.stringify(data.data))
                    let openid = data.data.openid
                    // let openid = 'osyLxsgbhd6D7oyVgEHS9ar-4Nfk'
                    localStorage.setItem("code", JSON.stringify(data.data))
                    localStorage.setItem("openId", openid) //保存openid
                    // console.log(data.data.member)
                    if(data.data.member){
                        localStorage.setItem("login", '1')
                    }else{
                        localStorage.setItem("login", '0')
                    }
                    let dt = new URLSearchParams()
                    dt.append('openid',openid)
                    this.$http.post('/sangto-wrm/vip/member/getByOpenId',dt).then(({data})=>{ //使用openid获取会员信息
                        if(data.code == 200 && data.data != null){
                            console.log(data.data)
                            let dataStr = JSON.stringify(data.data)
                            if(data.data.cardAccount){
                                localStorage.setItem("login", '1')
                            }else{
                                localStorage.setItem("login", '0')
                            }

                            localStorage.setItem("userData", dataStr)
                        }else{
                            this.UI.Toast.failed(data.message)
                        }
                    })
                })
            }




            document.title = "大转盘";
            let dt = new URLSearchParams();
            dt.append('id', this.$route.query.id);
            this.$http.post('/sangto-wrm/activity/game/getById', dt).then(({data}) => {

                this.gameData = data.data;
                this.canvasFn()
            })
        },
        data() {
            return {
                gameData: '',
                stop: null,
                ctx: '',
                boxWidth: "",
                R: '', //半径
                state: true,

            }
        },
        methods: {
            canvasFn() {
                let arr = this.gameData.gameItems;

                // let arr = [1, 2, 3, 4, 5, 6, 7, 8] //转盘数据
                // let color = ['#99FF01', '#33FF00', '#CCFF00', '#99FFCC', '#FFFFCC', '#66FF99', '#66FFFF', '#33CC99', '#FFCCFF', '#CCFF99', '#99FFFF']
                let canvas = document.getElementById('canvas');
                let boxWidth = document.querySelector('.scrollCent').getBoundingClientRect().width;
                this.boxWidth = boxWidth;
                // let len = arr.length
                canvas.width = boxWidth;
                canvas.height = boxWidth;
                let R = boxWidth / 2 - 26; //半径
                this.R = R;
                let ctx = canvas.getContext('2d');
                this.ctx = ctx;
                ctx.translate(boxWidth / 2, boxWidth / 2); //重新映射画布上的 (0,0) 位置。
                this.draw(ctx, R, arr);

                setTimeout(() => {
                    let img = this.$refs.imgel;
                    ctx.drawImage(img, 0, 0, 150, 238, -40, -70, 80, 120)
                }, 240)

            },
            draw(ctx, R, arr) {
                let len = arr.length;
                //绘制外圈
                ctx.beginPath();
                ctx.lineWidth = 16;
                ctx.strokeStyle = '#ea5455';
                ctx.arc(0, 0, R, 0, 2 * Math.PI);
                ctx.stroke();
                //绘制外圈上的圆点
                for (let i = 0; i < 18; i++) {
                    ctx.beginPath();
                    let r = (2 * Math.PI / 18) * i;
                    let x = Math.cos(r) * R;
                    let y = Math.sin(r) * R;
                    ctx.fillStyle = "#f9dd1d";
                    ctx.arc(x, y, 5, 0, 2 * Math.PI);
                    ctx.fill()
                }
                //绘制转盘分格

                for (let i = 0; i < len; i++) {
                    let a = (2 * Math.PI / len) * i; //起始弧度
                    let r = (2 * Math.PI / len) * (i + 1);//结束弧度
                    ctx.beginPath();
                    ctx.moveTo(0, 0);//每绘制一次将路径移动到圆点
                    ctx.fillStyle = arr[i].itemColor;
                    ctx.arc(0, 0, R - 8, a, r, false); //false顺时针绘图
                    ctx.fill()
                }
                //绘制装备分格中的文本内容
                for (let i = 0; i < len; i++) {
                    let b = Math.PI / len * i + Math.PI / len * (i + 1);
                    let x = Math.cos(b) * (R - 88);
                    let y = Math.sin(b) * (R - 88);
                    ctx.save();
                    // ctx.textAlign = "center" //横向对齐
                    ctx.textBaseline = "middle";  //纵向对齐
                    ctx.fillStyle = "yellow";
                    ctx.font = "12px MicrosoftJhengHei";
                    ctx.translate(x, y);
                    ctx.rotate(b);
                    ctx.fillText(arr[i].content, 0, 0);
                    ctx.restore()
                }
            },
            gotoRotate(e) {

                if (this.state) {

                    this.state = false
                    let x = e.offsetX;
                    let y = e.offsetY;

                    if ((x > 155 && x < 218) && (y > 157 && y < 220)) {
                        this.$http.get('/sangto-wrm/activity/game/getPrize', {
                            params: {
                                gameId: this.gameData.id,
                                openid: localStorage.getItem("openId")
                            }
                        }).then(({data}) => {

                            if (data.code == -1) {
                                this.UI.Toast.info(data.message);
                                return
                            }
                            let id = data.data.id;
                            let i = -1;
                            let arr = this.gameData.gameItems;
                            arr.forEach((item, index) => {
                                if (item.id == id) {
                                    i = index
                                }
                            });

                            let ar = 360 / arr.length;
                            let arS = (ar * i + 90) + (ar / 2);

                            let num = 0;
                            this.stop = setInterval(() => {
                                num += 6;
                                this.ctx.save();
                                this.ctx.clearRect(0, 0, this.boxWidth, this.boxWidth);
                                this.ctx.rotate(num * Math.PI / 180);
                                this.draw(this.ctx, this.R, arr);
                                if (num >= (1800 - arS)) {
                                    num = 0;
                                    clearInterval(this.stop);
                                    setTimeout(() => {
                                        this.state = true
                                        this.UI.Dialog.confirm({
                                            title: '抽奖提示',
                                            content: data.data.content,
                                            cancelText: '返回',
                                            confirmText: '继续抽奖',
                                            onConfirm: () => {
                                                this.canvasFn()
                                            },
                                            onCancel: () => {
                                                this.$router.go(-1)
                                            }
                                        })
                                    }, 700)
                                }
                                this.ctx.restore();
                                this.ctx.save();
                                let img = this.$refs.imgel;
                                this.ctx.drawImage(img, 0, 0, 150, 238, -40, -74, 84, 130);
                                this.ctx.restore()
                            }, 10)
                        })
                    }
                }

            }
        }
    }
</script>

<style scoped lang="scss">
    .gameWheelBox {
        width: 100%;
        height: 100%;

        .bgimg {
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
        }

        .scrollCent {
            position: relative;
            z-index: 1000;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
        }

        .title {
            margin-top: 16px;
            color: yellow;
        }

        #canvas {
            margin-top: 100px;
        }

        .imgStyle {
            width: 40px;
        }
    }
</style>
